import { useState } from 'react'
import { ResponseVariant } from 'workflow/Insights/Insights'

import CenterPanel from '../../components/layout/CenterPanel'
import PageDetails from '../../components/PageDetails'
import TweakVariantModal from '../../components/tweakVariantModal/TweakVariantModal'
import { useSelectedComponentElement } from '../../hooks'

import ManageApprovalsTable from './ManageApprovalsTable'
import VariantStatusFilters, { VariantStatus } from './VariantStatusFilters'

type Props = {
  statusFilter: VariantStatus
  onSelectVariant: (variant: ResponseVariant | undefined) => void
  tweakSuccessVariantIds: string[]
  selectedPersonalizationId: string | undefined
  onStatusFilterChange: (status: VariantStatus) => void
  onLoadingStateChange?: (hasLoadingVariants: boolean) => void
}

const ManageTableWithFilters = ({
  statusFilter,
  onSelectVariant,
  tweakSuccessVariantIds,
  selectedPersonalizationId,
  onStatusFilterChange,
  onLoadingStateChange,
}: Props) => {
  const { data: selectedElement } = useSelectedComponentElement()
  const [dynamicStatusCounts, setDynamicStatusCounts] =
    useState<
      | {
          pending: number
          live: number
          dropped: number
        }
      | undefined
    >()

  const getState = () => {
    if (!selectedElement) {
      return 'empty'
    } else if (selectedElement?.campaign_id) {
      return 'optimizeResults'
    } else {
      return 'personalizeResults'
    }
  }

  const state = getState()

  return (
    <>
      <CenterPanel
        data-testid="manageCenterPanel"
        className="flex-col overflow-auto pb-24"
      >
        {selectedElement && (
          <>
            <PageDetails
              title={`Manage: ${
                selectedElement?.display_name ?? selectedElement?.name
              }`}
              description="Review and act on new, live, and dropped variants to refine campaign performance."
              className="pb-8"
            />
            <VariantStatusFilters
              selectedStatus={statusFilter}
              onStatusChange={onStatusFilterChange}
              selectedElement={selectedElement}
              statusCounts={dynamicStatusCounts}
            />
          </>
        )}
        {state === 'empty' ? (
          <PageDetails
            title="Select an element to manage variants"
            description="Choose an element from the left panel to view and manage its variants."
          />
        ) : (
          <ManageApprovalsTable
            tweakSuccessVariantIds={tweakSuccessVariantIds}
            onSelectVariant={onSelectVariant}
            statusFilter={statusFilter}
            onStatusCountsChange={setDynamicStatusCounts}
            selectedPersonalizationId={selectedPersonalizationId}
            onLoadingStateChange={onLoadingStateChange}
          />
        )}
      </CenterPanel>
      <TweakVariantModal campaignType="linguo" />
    </>
  )
}

export default ManageTableWithFilters
